module.exports = __webpack_public_path__ + "static/media/stop.fc8693f8.svg";